"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBOUNCE_DELAY = exports.moment_value = exports.LONG_DATE_FORMAT_ISO = exports.ISO_DATETIME_SAVE_FORMAT = exports.ISO_TIME_FORMAT = exports.ISO_DATETIME_FORMAT = exports.ISO_DATE_FORMAT = exports.intersection = exports.groupBy = exports.Group = exports.setupJQuery = void 0;
var moment = require("moment");
require("url-search-params-polyfill");
require("shim-selected-options");
require("url-polyfill");
require("bootstrap");
require("@babel/polyfill");
var $ = require("jquery");
window.$ = window.jQuery = $;
function setupJQuery() {
    function getCookie(name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== "") {
            var cookies = document.cookie.split(";");
            for (var i = 0; i < cookies.length; i++) {
                var cookie = $.trim(cookies[i]);
                if (cookie.substring(0, name.length + 1) === name + "=") {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
    var csrftoken = getCookie("csrftoken");
    function csrfSafeMethod(method) {
        return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
    }
    $.ajaxSetup({
        beforeSend: function (xhr, settings) {
            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", csrftoken);
            }
        },
    });
}
exports.setupJQuery = setupJQuery;
var Group = (function () {
    function Group(key) {
        this.members = [];
        this.key = key;
    }
    return Group;
}());
exports.Group = Group;
function groupBy(array, func) {
    var res = [];
    var group = null;
    array.forEach(function (o) {
        var groupName = func(o);
        if (group === null) {
            group = new Group(groupName);
        }
        if (groupName !== group.key) {
            res.push(group);
            group = new Group(groupName);
        }
        group.members.push(o);
    });
    if (group != null) {
        res.push(group);
    }
    return res;
}
exports.groupBy = groupBy;
function intersection(array, other) {
    return array.filter(function (t) {
        return other.indexOf(t) !== -1;
    });
}
exports.intersection = intersection;
exports.ISO_DATE_FORMAT = "YYYY-MM-DD";
exports.ISO_DATETIME_FORMAT = "YYYY-MM-DD HH:mm";
exports.ISO_TIME_FORMAT = "HH:mm";
exports.ISO_DATETIME_SAVE_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
exports.LONG_DATE_FORMAT_ISO = {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: exports.ISO_DATE_FORMAT,
    l: "YYYY-M-D",
    LL: "YYYY Do MMMM",
    ll: "YYYY D MMM",
    LLL: "LL LT",
    lll: "ll LT",
    LLLL: "dddd, LL LT",
    llll: "ddd, ll LT",
};
function moment_value(value) {
    return value ? moment(value, exports.ISO_DATETIME_SAVE_FORMAT) : undefined;
}
exports.moment_value = moment_value;
setupJQuery();
moment.updateLocale("en", {
    longDateFormat: exports.LONG_DATE_FORMAT_ISO,
});
moment.updateLocale("da", {
    longDateFormat: exports.LONG_DATE_FORMAT_ISO,
});
moment.updateLocale("fi", {
    longDateFormat: exports.LONG_DATE_FORMAT_ISO,
});
moment.locale(language);
moment.weekdays(true);
exports.DEBOUNCE_DELAY = 600;
